import React from "react";
import { Col as Column, Container, Row } from "reactstrap";
import styled from "styled-components";
import { ExternalLink } from "../../components/library/Links";
import { SubHeader } from "../../components/library/Text";

const Wrapper = styled.div`
  background-color: #f6fcff;
`;

const FeatureBox = styled.div`
  text-align: center;
  padding: 105px 15px;
  max-width: 1230px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding: 105px 15px 0 15px;
  }
`;

const Header = styled(SubHeader)`
  margin-bottom: 1rem;
`;

const Text = styled.p`
  margin-bottom: 81px;

  @media screen and (max-width: 768px) {
    margin-bottom: 36px;
  }
`;

const Col = styled(Column)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Box = styled.div`
  width: 100%;
  height: 100%;
  max-width: 150px;
  max-height: 150px;
  margin: 0 auto;

  img {
    margin: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 36px;
  }
`;

const TTBox = styled(Box)`
  @media screen and (max-width: 768px) {
    margin-bottom: 18px;
  }
`;

const FeaturedLink = styled(ExternalLink)`
  padding: 0 !important;
`;

const EssenceWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 768px) {
    height: 150px;
  }
`;

const Essence = () => (
  <svg
    aria-hidden="true"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 406.0 128.16"
  >
    <g>
      <g>
        <path d="M24.38,32.2h40.26v10.41H36.49v12.37h27.55v10.41H36.49v13.22h28.15V89.1H24.38V32.2z"></path>
        <path d="M74.7,71.86c4.01,4.18,10.24,7.67,18.08,7.67c6.65,0,9.89-3.16,9.89-6.4c0-4.26-4.94-5.71-11.51-7.25 c-9.29-2.14-21.24-4.69-21.24-17.4c0-9.47,8.19-17.14,21.58-17.14c9.04,0,16.54,2.73,22.17,7.93l-6.73,8.87 c-4.61-4.26-10.74-6.23-16.29-6.23c-5.46,0-8.35,2.39-8.35,5.8c0,3.84,4.78,5.03,11.34,6.57c9.39,2.14,21.32,4.94,21.32,17.57 c0,10.41-7.42,18.25-22.77,18.25c-10.91,0-18.76-3.67-24.14-9.04L74.7,71.86z"></path>
        <path d="M123.73,71.86c4.01,4.18,10.24,7.67,18.08,7.67c6.65,0,9.89-3.16,9.89-6.4c0-4.26-4.95-5.71-11.51-7.25 c-9.29-2.14-21.24-4.69-21.24-17.4c0-9.47,8.19-17.14,21.58-17.14c9.04,0,16.54,2.73,22.17,7.93l-6.73,8.87 c-4.61-4.26-10.74-6.23-16.29-6.23c-5.46,0-8.35,2.39-8.35,5.8c0,3.84,4.78,5.03,11.34,6.57c9.39,2.14,21.32,4.94,21.32,17.57 c0,10.41-7.42,18.25-22.77,18.25c-10.91,0-18.76-3.67-24.14-9.04L123.73,71.86z"></path>
        <path d="M170.04,32.2h40.26v10.41h-28.15v12.37h27.55v10.41h-27.55v13.22h28.15V89.1h-40.26V32.2z"></path>
        <path d="M229.74,50.88v38.21h-12.11V32.2h12.45l26.35,36.84V32.2h12.11v56.89h-11.68L229.74,50.88z"></path>
        <path d="M274.94,60.69c0-17.48,13.22-29.42,29.85-29.42c12.96,0,20.22,6.82,24.22,13.9l-10.41,5.11 c-2.39-4.61-7.5-8.27-13.82-8.27c-9.89,0-17.4,7.94-17.4,18.68c0,10.74,7.5,18.68,17.4,18.68c6.31,0,11.43-3.58,13.82-8.27 l10.41,5.03c-4.09,7.08-11.26,13.99-24.22,13.99C288.16,90.11,274.94,78.16,274.94,60.69z"></path>
        <path d="M334.13,32.2h40.26v10.41h-28.15v12.37h27.55v10.41h-27.55v13.22h28.15V89.1h-40.26V32.2z"></path>
      </g>
    </g>
  </svg>
);

const TT = () => (
  <svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill="#000" cx="500" cy="500" r="500" />
      <g transform="translate(94 93)" fill="#FFF" fillRule="nonzero">
        <path d="M17.811 354.04L.284 354 0 458.96l17.568.04.121-43.126 87.27.203.041-18.708-87.27-.203zM124.176 208.253l38.292 22.318L172 214.26 80.647 161l-9.532 16.35 37.76 21.992-31.583 54.12-37.76-22.033L30 247.78 121.312 301l9.532-16.31-38.251-22.318zM163.768 82.513l15.356-10.898 60.977 85.86-15.356 10.898zM379.734 107.505L400 103.75 380.71 0l-18.476 3.47 14.325 77.25-73.333-66.225L283 18.292 302.249 122l18.517-3.43-14.285-76.76zM551.414 26.894c-32.547-12.484-61.774-.772-74.04 31.556-11.82 31.149.891 58.068 31.17 69.658 17.205 6.587 31.09 4.757 42.06-3.335l-5.586 14.72L561.94 146l20.24-53.27-54.041-20.698-5.87 15.411 37.04 14.192c-4.898 11.06-20.443 20.007-42.14 11.67-21.253-8.132-30.442-25.943-21.982-48.268 8.38-22.04 27.203-30.66 50.196-21.877 15.343 5.896 24.572 16.469 23.925 29.238l18.5 2.927c2.023-20.86-11.942-39.078-36.393-48.43zM643.998 224l67.744-55.788 27.628 33.497L753 190.502 685.664 109l-13.59 11.207 27.629 33.497L632 209.493zM708.835 385l17.262-3.836-13.744-61.702 27.162-5.999 12.558 56.56 17.262-3.836-12.558-56.56 24.257-5.387 13.704 61.743L812 362.147 794.206 282 691 304.853zM778.55 473.353c-23.284-7.004-33.478 14.819-42.245 33.565-6.81 14.576-12.764 27.491-23.651 24.212-9.053-2.713-11.5-13.928-7.055-28.544 5.056-16.56 15.373-26.034 29.85-25.386l1.997-19.11c-22.142-1.418-39.799 14.13-47.343 38.908-7.38 24.253-1.835 46.562 19.207 52.878 23.12 6.964 32.907-14.819 41.43-33.686 6.606-14.657 12.519-27.735 23.651-24.374 9.298 2.794 11.01 13.766 6.85 27.41-4.77 15.588-13.741 23.443-25.69 23.079l-1.304 18.624c18.92 1.134 35.028-11.337 42.572-36.156 7.136-23.442 2.773-45.104-18.268-51.42zM690.028 673.199L627.18 612 614 625.478l62.846 61.198-30.362 31.027L659.094 730 733 654.51l-12.61-12.338zM513.776 688.816l17.375-7.263 40.637 97.148-17.375 7.263zM426.892 787.124l-58.284-79.553L347.91 707 345 812.27l18.936.53 2.172-78.413 58.243 80.042 20.739.571L448 709.73l-18.977-.53zM245.18 658.325c-15.456-10.28-29.447-11.509-41.974-5.98l8.664-13.229L196.658 629l-31.398 47.919 48.521 32.232 9.07-13.843-33.229-22.116c7.199-9.789 24.403-15.154 43.885-2.212 19.075 12.697 24.24 32.192 11.063 52.301-13.015 19.823-33.351 24.164-53.972 10.444-13.788-9.174-20.54-21.625-17.082-33.994l-17.53-6.962c-6.507 20.068 3.254 41.079 25.176 55.66 29.243 19.413 60.439 14.334 79.473-14.745 18.384-28.014 11.754-57.257-15.455-75.36z" />
        <circle cx="79" cy="575" r="16" />
      </g>
    </g>
  </svg>
);

const Target = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    enableBackground="new 0 0 432 432"
    xmlSpace="preserve"
    viewBox="23.67 38.46 386.98 386.89"
  >
    <g>
      <g>
        <path
          fill="#000000"
          d="M217.074,360.93c-71.239,0-129.052-57.721-129.052-128.972c0-71.38,57.813-129.059,129.052-129.059    c71.301,0,129.042,57.679,129.042,129.059C346.116,303.209,288.375,360.93,217.074,360.93 M217.074,38.459    c-106.796,0-193.399,86.625-193.399,193.499c0,106.792,86.603,193.39,193.399,193.39c106.842,0,193.581-86.598,193.581-193.39    C410.655,125.084,323.916,38.459,217.074,38.459z"
        />
        <path
          fill="#000000"
          d="M217.074,165.651c-36.607,0-66.268,29.589-66.268,66.307c0,36.597,29.66,66.274,66.268,66.274    c36.642,0,66.367-29.678,66.367-66.274C283.441,195.241,253.716,165.651,217.074,165.651"
        />
      </g>
    </g>
  </svg>
);

const Featured = () => (
  <Wrapper>
    <FeatureBox>
      <Header>It takes a village</Header>
      <Text>See who we've collaborated with to bring Wavy Blue to life.</Text>
      <Container fluid data-aos="fade-down">
        <Row>
          <Col md={3}>
            <FeaturedLink href="https://www.glossier.com/blog/grant-recipients">
              <Box>
                <img
                  src="https://static.wavyformula.com/images/glossier-badge-black.png"
                  alt="Glossier badge"
                />
              </Box>
            </FeaturedLink>
          </Col>
          <Col md={3}>
            <Box>
              <div>
                <Target />
              </div>
            </Box>
          </Col>
          <Col md={3}>
            <FeaturedLink href="https://www.essence.com/beauty/glossiers-black-owned-beauty-business-grant-recipients/#568224">
              <Box>
                <EssenceWrapper>
                  <Essence />
                </EssenceWrapper>
              </Box>
            </FeaturedLink>
          </Col>
          <Col md={3}>
            <FeaturedLink href="https://thingtesting.com/brands/wavy-blue">
              <TTBox>
                <div>
                  <TT />
                </div>
              </TTBox>
            </FeaturedLink>
          </Col>
        </Row>
      </Container>
    </FeatureBox>
  </Wrapper>
);

export default Featured;
